







































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { Message } from 'element-ui'
import http from '../unite/http'
@Component({
  components: {}
})
export default class Dialog extends Vue {
  @Prop() optionTitle: any
  @Prop() rules: any
  @Prop() formList: any
  loading: boolean = false
  dialogVisible: boolean = true
  num: number = 0
  numWidth: string = '50%'
  // 确认
  confirm(formName: any) {
    ;(this.$refs[formName] as any).validate((valid: boolean) => {
      if (valid) {
        this.loading = true
        http
          .request({
            url: this.formList.url,
            method: this.formList.type,
            data: this.formList.form
          })
          .then(d => {
            this.loading = false
            this.$emit('refesh', true)
            Message({
              message: '操作成功',
              type: 'success',
              duration: 5 * 1000
            })
          })
          .catch(e => {
            this.loading = false
          })
      }
    })
  }
  // 取消
  cancel() {
    this.$emit('refesh', false)
  }
}
